/**
 * AddFeaturedRowItemsCtrl controller
 */
// preload drag'n'drop image
const dragndropImg = new window.Image()
dragndropImg.src = require('../../img/dragndrop.png')

// controller mixins
AddSlotsCtrl.mixes = [
  'openPopupCtrlMixin'
]

/* @ngInject */

export default function AddSlotsCtrl (
  $scope,
  $uibModalInstance,
  $http,
  contentItems,
  contentType,
  shelf,
  subscriptions,
  packgId,
  storageSvc
) {
  const vm = this

  const allRatings = { rating: 'All Ratings', name: '', id: null, selected: true }

  const ageRatings = JSON.parse(storageSvc.local.get('ageRatings'))

  ageRatings.defaultAgeRatings.forEach(ar => { ar.name = 'Default Age Ratings' })

  vm.ageRatings = [allRatings, ...ageRatings.defaultAgeRatings]

  for (const ageRating of ageRatings.customAgeRatings) {
    for (const ageRatingElement of ageRating.ageRatings) {
      const el = { ...ageRating }
      delete el.ageRatings
      vm.ageRatings.push({ ...el, ...ageRatingElement })
    }
  }

  vm.ageRatingAvailable = angular.copy(vm.ageRatings)
  vm.ageRatingAssigned = angular.copy(vm.ageRatings)
  vm.availableFilterAgeRating = angular.copy(allRatings)
  vm.assignedFilterAgeRating = angular.copy(allRatings)

  vm.makeAgeRatingConfig = function (type) {
    const config = {}

    if (type === 'available') {
      config.ageRatings = vm.ageRatingAvailable
      config.getItems = vm.getAvailableItems
    } else {
      config.ageRatings = vm.ageRatingAssigned
      config.getItems = vm.getAssignedItems
    }

    return config
  }

  vm.selectAR = function (arId, type = 'available', event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }

    const config = vm.makeAgeRatingConfig(type)

    // Find the actual object in the array by ID
    const ar = config.ageRatings.find(rating => rating.id === arId)
    if (!ar) return

    // Toggle the selected state manually
    const newValue = !ar.selected

    if (ar.id === null) {
      // "All Ratings" was clicked
      if (newValue) {
        // Select "All Ratings" and deselect all other ratings
        config.ageRatings.forEach(f => {
          f.selected = f.id === null
        })
      } else {
        // Prevent deselecting "All Ratings" if no other ratings are selected
        ar.selected = true
      }
    } else {
      // A specific rating was clicked
      ar.selected = newValue

      if (newValue) {
        // Specific rating was selected - deselect "All Ratings"
        config.ageRatings[0].selected = false
      } else {
        // Specific rating was deselected - check if we need to auto-select "All Ratings"
        const hasSelection = config.ageRatings.some(rating => rating.id !== null && rating.selected)
        if (!hasSelection) {
          config.ageRatings[0].selected = true
        }
      }
    }

    if (type === 'available') {
      vm.getAvailableItems(true)
    }
  }

  vm.getAgeFilterNames = function (type = 'available') {
    const config = vm.makeAgeRatingConfig(type)

    return config.ageRatings.filter(ar => ar.selected).map(ar => ar.rating).join(', ')
  }

  vm.subscriptions = [{ name: 'All Subscriptions', id: 'ALL' }, { name: 'Without Subscription', id: 'ANY' }, ...subscriptions]

  vm.removedItems = []

  vm.shelf = shelf

  vm.contentType = contentType

  vm.contentItems = { assigned: { }, available: { } }
  vm.contentItems.assigned.items = angular.copy(shelf.slots)
  vm.initialAssigned = angular.copy(contentItems)

  vm.availableFilter = ''
  vm.availableFilterSubscription = { name: 'All Subscriptions', id: 'ALL' }
  vm.availableFilterContentSet = { name: 'All Content Sets', id: 'ALL' }

  vm.assignedFilter = ''
  vm.assignedFilterSubscription = { name: 'All Subscriptions', id: 'ALL' }
  vm.assignedFilterContentSet = { name: 'All Content Sets', id: 'ALL' }

  vm.isFormDisabled = true

  // Initialize content sets state
  vm.resetContentSetsListState = false
  vm.availableFilterContentSetsState = angular.copy(vm.initListState)
  vm.assignedFilterContentSetsSate = angular.copy(vm.initListState)
  vm.contentSets = []
  vm.availableContentSets = []
  vm.assignedContentSets = []
  vm.initialContentSets = [{ name: 'All Content', id: 'ALL' }, { name: 'Without Content Set', id: 'ANY' }]

  /**
   * Table state for pageable request
   *
   * @memberof mwApp/packages.controller:AddContentSets
   * Ctrl
   */
  vm.initListState = {
    page: 0,
    count: 25,
    q: ''
  }

  vm.onFilterSubscriptionSelect = function (type) {
    vm[type + 'ContentSets'] = []

    vm[type + 'FilterContentSet'] = { name: 'All Content Sets', id: 'ALL' }

    if (type === 'available') {
      vm.getAvailableItems(true)
    }
  }

  vm.loadContentSets = function (type, event) {
    if (event) {
      // Clear previous timeout
      if (vm.csScrollTimeout) {
        clearTimeout(vm.csScrollTimeout)
      }

      // Debounce scroll events
      vm.csScrollTimeout = setTimeout(() => {
        const element = event.target
        if (!element) {
          return
        }

        const scrollTop = element.scrollTop
        const scrollHeight = element.scrollHeight
        const clientHeight = element.clientHeight

        // Load more when user scrolls to 80% of the list
        if (scrollTop + clientHeight >= scrollHeight * 0.8) {
          if (!vm.loading && !vm[type + 'FilterContentSetsSate'].last) {
            vm.getContentSets(type, false)
          }
        }
      }, 500) // 100ms debounce
    } else {
      if (!vm[type + 'ContentSets']?.length) {
        vm.getContentSets(type, true)
      }
    }
  }

  vm.getContentSets = function (type, resetState = false) {
    if (resetState || vm.resetContentSetsListState) {
      vm.resetContentSetsListState = false
      vm[type + 'FilterContentSetsSate'] = angular.copy(vm.initListState)
    } else {
      vm[type + 'FilterContentSetsSate'].page++
    }

    const url = `api/networks/${packgId}/${contentType.setType}`
    const params = {
      page: vm[type + 'FilterContentSetsSate'].page,
      count: vm[type + 'FilterContentSetsSate'].count,
      'sort-order': 'asc',
      q: vm[type + 'FilterContentSetsSate'].q || ''
    }
    if (typeof vm[type + 'FilterSubscription'].id === 'number') {
      params.subscriptions = vm[type + 'FilterSubscription'].id
    } else {
      params.subscriptions = ''
    }

    vm.loading = true

    return $http.get(url, { params })
      .then((response) => {
        const data = response.data.payload
        vm[type + 'FilterContentSetsSate'].last = data.last
        vm[type + 'FilterContentSetsSate'].page = data.number

        if (resetState) {
          vm[type + 'ContentSets'] = vm.initialContentSets.concat(data.content || [])
        } else {
          vm[type + 'ContentSets'] = vm[type + 'ContentSets'].concat(data.content || [])
        }

        // If we have few items and there are more pages, load more
        if (vm[type + 'ContentSets'].length < vm[type + 'FilterContentSetsSate'].count && !vm[type + 'FilterContentSetsSate'].last) {
          vm.getContentSets(type, false)
        } else {
          vm.loading = false
        }

        return data
      })
      .catch((error) => {
        vm.loading = false
        console.error('Error loading content sets:', error)
        return Promise.reject(error)
      })
  }

  vm.getAvailableItems = function (resetState = false) {
    if (resetState) {
      vm.listState = angular.copy(vm.initListState)
      vm.listState.q = vm.availableFilter
      vm.listState.contentType = shelf.contentType

      if (vm.availableFilterSubscription) {
        vm.listState.filterBySubscriptions = vm.availableFilterSubscription.id !== 'ALL'

        vm.listState.subscriptionIds = vm.listState.filterBySubscriptions && vm.availableFilterSubscription.id !== 'ANY' ? [vm.availableFilterSubscription.id] : []
      }

      if (vm.availableFilterContentSet) {
        vm.listState.filterByContentSets = vm.availableFilterContentSet.id !== 'ALL'

        vm.listState.contentSetIds = vm.listState.filterByContentSets && vm.availableFilterContentSet.id !== 'ANY' ? [vm.availableFilterContentSet.id] : []
      }

      vm.listState.ageRatingIds = vm.makeAgeRatingConfig('available')
        .ageRatings.filter(ar => ar.selected).map(ar => ar.id).join(', ')
    } else {
      vm.listState.page++
    }

    vm.loading = true

    shelf._loadItems({ ...vm.listState })
      .then((res) => {
        vm.listState.last = res.last
        vm.listState.page = res.number
        if (resetState) {
          vm.contentItems.available.items = res.content.filter(c => !vm.contentItems.assigned.items.find(item => item.contentId === c.contentId))
        } else {
          vm.contentItems.available.items = vm.contentItems.available.items.concat(res.content.filter(c => !vm.contentItems.assigned.items.find(item => item.contentId === c.contentId)))
        }
        if (!vm.contentItems.available.items.length && !res.last) {
          vm.getAvailableItems()
        } else {
        }
      }).catch(err => {
        console.error('Error loading items:', err)
      })
      .finally(() => {
        vm.loading = false
      })
  }

  /**
   * Handle scroll event for infinite loading
   * @param {Event} event - The scroll event
   */
  vm.onAvailableScroll = function (event) {
    // Clear previous timeout
    if (vm.scrollTimeout) {
      clearTimeout(vm.scrollTimeout)
    }

    // Debounce scroll events
    vm.scrollTimeout = setTimeout(() => {
      const element = event.target
      if (!element) {
        return
      }

      const scrollTop = element.scrollTop
      const scrollHeight = element.scrollHeight
      const clientHeight = element.clientHeight

      // Load more when user scrolls to 80% of the list
      if (scrollTop + clientHeight >= scrollHeight * 0.8) {
        if (!vm.loading && !vm.listState.last) {
          vm.getAvailableItems()
        }
      }
    }, 100) // 100ms debounce
  }

  // Initialize listState
  vm.listState = angular.copy(vm.initListState)

  vm.getAvailableItems(true)

  /// / dnd

  /**
   * In the dnd-drop callback, we now have to handle the data array that we
   * sent above. We handle the insertion into the list ourselves. By returning
   * true, the dnd-list directive won't do the insertion itself.
   */
  vm.onDrop = function (list, items, index, event) {
    event.stopPropagation()
    list.items = list.items
      .slice(0, index)
      .concat(items)
      .concat(list.items.slice(index))
    items.forEach(item => { item.selected = !item.selected })
    vm.isFormDisabled = false
    return true
  }

  /**
   * dnd-dragging determines what data gets serialized and send to the receiver
   * of the drop. While we usually just send a single object, we send the array
   * of all selected items here.
   */
  vm.getSelected = function (list, link) {
    // eslint-disable-next-line no-undef
    event.stopPropagation()
    link.selected = true
    return list.filter(link => link.selected)
  }
  /**
   * Delete item from contentItems
   *
   * @memberof mwApp/addFeaturedRowItems.controller:AddFeaturedRowItemsCtrl
   */
  vm.deleteItem = function (item, event) {
    event.preventDefault()
    item.selected = false
    vm.contentItems.assigned.items = vm.contentItems.assigned.items.filter(i => i.contentId !== item.contentId)
    if (!vm.contentItems.available.items.find(i => i.contentId === item.contentId)) {
      vm.contentItems.available.items.push(item)
    }
    vm.isFormDisabled = false
  }

  /**
   * We set the list into dragging state, meaning the items that are being
   * dragged are hidden. We also use the HTML5 API directly to set a custom
   * image, since otherwise only the one item that the user actually dragged
   * would be shown as drag image.
   */
  vm.onDragstart = function (list, event) {
    list.dragging = true
    if (event.dataTransfer.setDragImage) {
      event.dataTransfer.setDragImage(dragndropImg, 0, 0)
    }
  }

  /**
   * We set the list into dragging state, meaning the items that are being
   * dragged are hidden. We also use the HTML5 API directly to set a custom
   * image, since otherwise only the one item that the user actually dragged
   * would be shown as drag image.
   */
  vm.onDragend = function (list) {
    list.forEach(item => {
      item.selected = false
    })
    list.dragging = false
  }

  /**
   * Last but not least, we have to remove the previously dragged items in the
   * dnd-moved callback.
   */
  vm.onMoved = function (list) {
    list.items = list.items.filter(item => !item.selected)
  }

  /**
   * Method for filtering sets by name
   *
   * @param {Object} contentItem
   * @memberof mwApp/packages.controller:AddAddonsCtrl
   */
  vm.filteredAssigned = (contentItem) => {
    const titleFilter = vm.assignedFilter.length > 0
      ? contentItem.title.toLowerCase().includes(vm.assignedFilter.toLowerCase())
      : true

    let subscriptionsFilter = true
    if (vm.assignedFilterSubscription.id !== 'ALL') {
      if (vm.assignedFilterSubscription.id === 'ANY') {
        subscriptionsFilter = !contentItem.subscriptions.length
      } else {
        subscriptionsFilter = !vm.assignedFilterSubscription || contentItem.subscriptions?.some(s => s.id === vm.assignedFilterSubscription.id)
      }
    }

    let contentSetsFilter = true
    if (vm.assignedFilterContentSet.id !== 'ALL') {
      if (vm.assignedFilterContentSet.id === 'ANY') {
        contentSetsFilter = !contentItem.contentSets.length
      } else {
        contentSetsFilter = !vm.assignedFilterContentSet || contentItem.contentSets?.some(s => s.id === vm.assignedFilterContentSet.id)
      }
    }

    let ageRatingFilter = true
    if (vm.assignedFilterAgeRating.id) {
      ageRatingFilter = !!vm.ageRatingAssigned.filter(ar => (ar.id === contentItem.ageRatingId) && ar.selected).length
    }

    return titleFilter && subscriptionsFilter && contentSetsFilter && ageRatingFilter
  }

  /**
   * Cancel editing, close modal window
   *
   * @memberof mwApp/addContentSets.controller:AddFeaturedRowItemsCtrl
   */
  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel')
  }

  /**
   * Create or edit season, and close modal window afterwards
   *
   * @memberof mwApp/addContentSets.controller:AddFeaturedRowItemsCtrl
   */
  vm.submit = function () {
    $uibModalInstance.close(vm.contentItems.assigned.items)
  }

  /**
   * Cleanup on scope destroy
   */
  $scope.$on('$destroy', function () {
    if (vm.scrollTimeout) {
      clearTimeout(vm.scrollTimeout)
    }
  })
}
